<div class="profile-tab">
  <div class="row">
    <!-- Left Column -->
    <div class="col-md-6">
      <div class="form-group">
        <label class="col-md-6 control-label" for="unitNumber">UNIT NUMBER</label>
        <div class="col-md-6 inputSpace">
          <input
            id="unitNumber"
            name="unitNumber"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.trailerNo"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="equipmentCode">EQUIPMENT CODE</label>
        <div class="col-md-6 inputSpace">
          <select
            id="equipmentCode"
            name="equipmentCode"
            class="form-control"
            [(ngModel)]="equipmentCodeSelected"
            (ngModelChange)="onEquipmentCodeChange()"
            [disabled]="!isEditMode"
            [compareWith]="compareEquipmentCode"
          >
            <option [ngValue]="null">--Select one--</option>
            <option *ngFor="let code of equipmentCodes" [ngValue]="code">
              {{ code.equipmentCode }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="unNumbers">UN NUMBERS</label>
        <div class="col-md-6 inputSpace">
          <ul
            *ngIf="
              equipmentCodeSelected &&
              equipmentCodeSelected.un &&
              equipmentCodeSelected.un.length > 0
            "
            style="list-style-type: disc; padding-left: 20px; margin: 0"
          >
            <li
              *ngFor="let unNumber of equipmentCodeSelected.un; let i = index"
              style="color: #555"
            >
              {{
                equipmentCodeSelected.name && equipmentCodeSelected.name[i]
                  ? equipmentCodeSelected.name[i] + ": "
                  : ""
              }}{{ unNumber }}
            </li>
          </ul>
          <span
            *ngIf="
              !equipmentCodeSelected ||
              !equipmentCodeSelected.un ||
              equipmentCodeSelected.un.length === 0
            "
            style="color: #999"
          >
            No UN numbers available
          </span>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="trailerType">TRAILER TYPE</label>
        <div class="col-md-6 inputSpace">
          <select
            id="trailerType"
            name="trailerType"
            class="form-control"
            [(ngModel)]="trailer.trailerType"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          >
            <option value="">Select Trailer Type</option>
            <option *ngFor="let option of trailerTypeOptions" [ngValue]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="trailerStatus">TRAILER STATUS</label>
        <div class="col-md-6 inputSpace">
          <select
            id="trailerStatus"
            name="trailerStatus"
            class="form-control"
            [(ngModel)]="trailer.status"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          >
            <option *ngFor="let option of trailerStatusOptions" [ngValue]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="assignedDriver">ASSIGNED DRIVER</label>
        <div class="col-md-6 inputSpace">
          <select
            id="assignedDriver"
            name="assignedDriver"
            class="form-control"
            [(ngModel)]="trailer.driverId"
            (ngModelChange)="onDriverChange()"
            [disabled]="!isEditMode"
          >
            <option [ngValue]="null">--Select Driver--</option>
            <option *ngFor="let driver of drivers" [ngValue]="driver.id">
              {{ driver.itemName || driver.lastName + ", " + driver.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="year">YEAR</label>
        <div class="col-md-6 inputSpace">
          <input
            id="year"
            name="year"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.year"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="make">MAKE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="make"
            name="make"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.make"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="model">MODEL</label>
        <div class="col-md-6 inputSpace">
          <input
            id="model"
            name="model"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.model"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="mobileDeviceType">MOBILE DEVICE TYPE</label>
        <div class="col-md-6 inputSpace">
          <select
            id="mobileDeviceType"
            name="mobileDeviceType"
            class="form-control"
            [(ngModel)]="trailer.mobileDeviceType"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          >
            <option value="">Select Mobile Device Type</option>
            <option *ngFor="let option of mobileDeviceTypeOptions" [ngValue]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="mobileDeviceNumber">MOBILE DEVICE NUMBER</label>
        <div class="col-md-6 inputSpace">
          <input
            id="mobileDeviceNumber"
            name="mobileDeviceNumber"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.mobileDeviceNumber"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="serial">TRAILER SERIAL</label>
        <div class="col-md-6 inputSpace">
          <input
            id="serial"
            name="serial"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.serial"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="vinNo">VIN NUMBER</label>
        <div class="col-md-6 inputSpace">
          <input
            id="vinNo"
            name="vinNo"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.vinNo"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="col-md-6">
      <div class="form-group">
        <label class="col-md-6 control-label" for="terminalLocation">TERMINAL LOCATION</label>
        <div class="col-md-6 inputSpace">
          <select
            id="terminalLocation"
            name="terminalLocation"
            class="form-control"
            [(ngModel)]="trailer.terminalLocation"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          >
            <option value="">--Select Terminal--</option>
            <option *ngFor="let terminal of terminals" [ngValue]="terminal">
              {{ terminal }}
            </option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="currentLocationState">CURRENT LOC STATE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="currentLocationState"
            name="currentLocationState"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.currentLocationState"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="currentLocationCity">CURRENT LOC CITY</label>
        <div class="col-md-6 inputSpace">
          <input
            id="currentLocationCity"
            name="currentLocationCity"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.currentLocationCity"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="datePurchased">DATE PURCHASED</label>
        <div class="col-md-6 inputSpace">
          <input
            id="purchasedDate"
            name="purchasedDate"
            type="text"
            class="form-control"
            [inputMask]="dateInputMask"
            placeholder="mm/dd/yyyy"
            [(ngModel)]="trailer.purchasedDate"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="purchasePrice">PURCHASE PRICE</label>
        <div class="col-md-6 inputSpace">
          <input
            id="purchasePrice"
            name="purchasePrice"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.purchasePrice"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="insuranceName">INSURANCE NAME</label>
        <div class="col-md-6 inputSpace">
          <input
            id="insuranceName"
            name="insuranceName"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.insuranceName"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="insurancePolicyNumber"
          >INSURANCE POLICY NUMBER</label
        >
        <div class="col-md-6 inputSpace">
          <input
            id="insurancePolicyNumber"
            name="insurancePolicyNumber"
            type="text"
            class="form-control"
            [(ngModel)]="trailer.insurancePolicyNumber"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
          />
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="notes">NOTES</label>
        <div class="col-md-6 inputSpace">
          <textarea
            id="notes"
            name="notes"
            class="form-control"
            rows="3"
            [(ngModel)]="trailer.notes"
            (ngModelChange)="onFieldChange()"
            [disabled]="!isEditMode"
            maxlength="1000"
          ></textarea>
        </div>
      </div>

      <div class="form-group">
        <label class="col-md-6 control-label" for="isActive">Active</label>
        <div class="col-md-6 inputSpace">
          <p-checkbox
            id="isActive"
            name="isActive"
            [(ngModel)]="trailer.isActive"
            (ngModelChange)="onFieldChange()"
            binary="true"
            [disabled]="!isEditMode"
          ></p-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>
